import { object, string } from 'yup';

import { I18nService } from '~shared/lib';

export const validationSchema = object({
  title: string().required(() => I18nService.t('Validation.RequiredField')),
});
